export default "__VITE_ASSET__50ebf5b9__"